import { WebsiteConfiguration } from '@/kontent/content-types'
import { Responses } from '@kontent-ai/delivery-sdk'
import { createContext, useContext } from 'react'

export const WebsiteConfigurationContext =
	createContext<Responses.IViewContentItemResponse<WebsiteConfiguration> | null>(
		null,
	)

export const useWebsiteConfiguration = () => {
	const value = useContext(WebsiteConfigurationContext)
	return value
}
